export default "<div class=\"blue\">\n    <div class=\"white\">\n        <app-competition-list></app-competition-list>\n    </div>\n</div>";